import cx from 'classnames';
import Typography from '@navi/web-ui/lib/primitives/Typography/index';
import Tooltip, { directions } from '../../Tooltip';
import CircularProgress from '../../ProgressBars/circularProgress/CircularProgress';
import TooltipContent from './TooltipContent';
import styles from './index.module.scss';
import { TooltipCircularProgressProps } from './interface';

const TooltipCircularProgress = (props: TooltipCircularProgressProps) => {
  const { isVisible, percentCompletedCases, completedCasesPercent } = props;

  if (!isVisible) return null;

  return (
    <div className={cx([styles.ProgressBar, styles.circularProgress])}>
      <Tooltip
        direction={directions.RIGHT}
        content={
          <TooltipContent
            percentCompletedCases={percentCompletedCases}
            completedCasesPercent={completedCasesPercent}
          />
        }
      >
        <CircularProgress
          percentage={completedCasesPercent}
          sqSize={24}
          strokeWidth={4}
          withAnimation={true}
        />
      </Tooltip>
      <div className={styles.ProgressPercent}>
        <Typography variant="p2" color="var(--navi-color-gray-bg-primary)">
          {completedCasesPercent}%
        </Typography>
      </div>
    </div>
  );
};

export default TooltipCircularProgress;
